import { TimeOffBalance, ErpContractor } from 'api';

export default function createTimeOffBalance(
  daysOffInfo: ErpContractor['daysOffInfo'] = [],
): TimeOffBalance[] {
  if (!Array.isArray(daysOffInfo)) return [];

  return daysOffInfo.flatMap(({ daysOffBalanceInfo, timeOffType: { name, balance } }) =>
    Object.entries(daysOffBalanceInfo)
      .filter(([, value]) => value)
      .map(([key, value]) => ({
        name: `${name}${key !== 'current' ? ` (${key} year)` : ''}`,
        left: value?.left ?? 0,
        used: value?.used ?? 0,
        balance,
      })),
  );
}
